import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface GetExtra {
	uriParams: Api.Operations['getExtra']['parameters']['path']
	params?: Api.Operations['getExtra']['parameters']['query']
	response: Api.Operations['getExtra']['responses']['200']['content']['application/json']
}

export const getExtra = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<GetExtra>(
		{
			method: 'get',
			url: '/extras/{extraId}',
			...overideConfig,
		},
		axiosInstance,
	)
